import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { RiFileExcel2Fill } from 'react-icons/ri';
import { CSVLink } from "react-csv";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



export default class ExportarCSVreporte extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            arraycsv: [],
            totalitems: 0,
            title: ""
        }

    }

    componentDidMount() {

        var arraycsve = this.props.arraycsv;

        this.setState({ arraycsv: arraycsve })

    }


    render() {
        return (
            <>
                <ToastContainer />
                {this.state.arraycsv.length > 0 ?
                    <CSVLink data={this.state.arraycsv} filename={"Reporte"} enclosingCharacter={``} separator={","} style={{ margin: 'auto' }} >
                        <RiFileExcel2Fill className="consulta-archivos-excel" style={{ color: "#1f6e43", fontSize: "30px", margin: 'auto' }} />
                    </CSVLink>
                    :
                    <RiFileExcel2Fill className="consulta-archivos-excel" style={{ color: "#1f6e43", fontSize: "30px", margin: 'auto' }} />
                }

            </>
        )
    }
}

